class ChangePasswordController {
  constructor(
    $scope,
    $uibModalInstance,
    $q,
    StaffUserService,
    LogService,
    message,
    title
  ) {
    "ngInject";
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$q = $q;
    this.StaffUserService = StaffUserService;
    this.LogService = LogService;
    this._message = message;
    this._title = title;

    this._passwordValidityCheck = {};
    this._lastPasswordChecked = null;

    this.oldPassword = '';
    this.newPassword = '';
    this.newPasswordConfirm = '';
    this.errors = [];

    this._updating = false;
  }

  get passwordValidityCheck() {
    return this._passwordValidityCheck;
  }

  get updating() {
    return this._updating;
  }

  confirm() {
    this._updating = true;
    this.StaffUserService.changePassword(this.oldPassword, this.newPassword, this.newPasswordConfirm)
      .catch(error => {
        this.LogService.error("ChangePasswordModal got error:", error);
        if (error && error.errors) {
          this.errors = error.errors;
        }
        return this.$q.reject(error);
      })
      .then(result => {
        if (result.success) {
          // Success!
          return this.$uibModalInstance.close();
        } else {
          this.LogService.warn(`ChangePasswordController failed to update password. Result:`, result);
          this.errors = result.errors;
        }
      })
      .finally(() => {
        this._updating = false;
      });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  get message() {
    return this._message;
  }

  get title() {
    return this._title;
  }

  validatePassword() {
    const checkPassword = this.newPassword;
    if (this._lastPasswordChecked === checkPassword) {
      // Don't check the same password twice in a row...
    } else {
      this._updating = true;
      this.StaffUserService.validatePassword(checkPassword)
        .then(response => {
          this._lastPasswordChecked = checkPassword;
          if (response.success === false) {
            this.$scope.form.new_password.$setValidity('ValidPassword', false);
            this._passwordValidityCheck = response;
          } else {
            this.$scope.form.new_password.$setValidity('ValidPassword', true);
            this._passwordValidityCheck = {};
          }
        })
        .finally(() => {
          this._updating = false;
        });
    }
  }
}

export default ChangePasswordController;
